import { serviceMaker, methods, api } from "../index.js";

export const fetchSimInfo = (data) => {
  const url = `extrnal/inventory/items/serialNo?comodityType=${data.comodityType}&subsType=${data.subsType}`;
  return serviceMaker(url, methods.GET, api.NGB);
};
export const fetchPostpaidInfo = (data) => {
  const url = `extrnal/inventory/items/serialNumber?search=${data.search}`;
  return serviceMaker(url, methods.GET, api.NGB);
};

export const fetchPlanInfo = (data) => {
  const url = `plans/getPlans`;
  return serviceMaker(url, methods.POST, api.NGB, data);
};
export const getPlanCategory = () =>
  serviceMaker(`/mcodes/Plan_category`, methods.GET, api.NGB);

export const fetchBillCycle = (code) => {
  const url = `codes/${code}/codevalues`;
  return serviceMaker(url, methods.GET, api.NGB);
};
export const fetchMonthlyData = (data) => {
  const url = `discountrate/${data.planId}/Online/${data.month}`;
  return serviceMaker(url, methods.GET, api.NGB);
};
export const fetchContentData = (data) => {
  const url = `plan/${data}/documents/plan/${data}`;
  return serviceMaker(url, methods.GET, api.NGB);
};
export const reserveApi = (data) => {
  const url = `/extrnal/inventory/items/${data.comodityType}/reserve`;
  return serviceMaker(url, methods.POST, api.NGB, data.data);
};
export const sendLink = (data) => {
  const url = `/api/payment-link`;
  return serviceMaker(url, methods.POST, api.NGB_PAYMENT, data);
};
export const paymentStatus = (id) => {
  const url = `/api/payment-link-status?id=${id}`;
  return serviceMaker(url, methods.GET, api.NGB_PAYMENT);
};
export const paymentsDetailsApi = (data) => {
  const url = `/api/payments/details`;
  return serviceMaker(url, methods.POST, api.NGB_PAYMENT, data);
};
export const paymentsMethodsApi = (data) => {
  const url = `/api/payment-methods`;
  return serviceMaker(url, methods.POST, api.NGB_PAYMENT, data);
};
export const makePaymentApi = (data) => {
  const url = `/api/payments`;
  return serviceMaker(url, methods.POST, api.NGB_PAYMENT, data);
};
export const afterPaymentApi = (data) => {
  const url = `/payments/${data.id}`;
  return serviceMaker(url, methods.POST, api.NGB, data.data);
};
export const paymentCompletedApi = (data) => {
  const url = `/api/payment-completed`;
  return serviceMaker(url, methods.POST, api.NGB_PAYMENT, data);
};
export const getOrderStatusApi = ({ orderId, redirectResult }) => {
  const url = `/adyen/getorderstatus/${orderId}?redirectResult=${redirectResult}`;
  return serviceMaker(url, methods.GET, api.NGB);
};
export const addressByZipCode = (data) => {
  const url = `/api/global-address`;
  return serviceMaker(url, methods.POST, api.NGB_SOCKET, data);
};
export const getPreferLanguages = () => {
  const url = `/mcodes/Prefer Language`;
  return serviceMaker(url, methods.GET, api.NGB);
};
export const getSourceTypes = () => {
  const url = `/mcodes/Source type`;
  return serviceMaker(url, methods.GET, api.NGB);
};
export const getBillCycles = () => {
  const url = `/billcycle`;
  return serviceMaker(url, methods.GET, api.NGB);
};
export const simpleActivationPost = (data) =>
  serviceMaker(
    `/activationprocess/activationonpayment`,
    methods.POST,
    api.NGB,
    data
  );
